module.exports = __webpack_public_path__ + "img/Principal.ad8b8cac.png";